import type {ColorScheme} from '$lib/classes/_types/color-scheme';

export class ThemeManager {
    constructor() {}

    private readonly key = 'data-theme'

    private applyTheme(theme: ColorScheme | null | undefined) {
        if (theme) {
            document.documentElement.setAttribute(this.key, theme)
        } else {
            document.documentElement.removeAttribute(this.key)
        }
    }

    private persistTheme(theme: ColorScheme | null | undefined) {
        try {
            if (theme) {
                localStorage.setItem(this.key, theme)
            } else {
                localStorage.removeItem(this.key)
            }
        } catch (error) {
            console.error('ERROR persisting theme to localStorage', error)
        }
    }

    set(theme: ColorScheme | null | undefined) {
        this.applyTheme(theme)
        this.persistTheme(theme)
    }

    reset() {
        // -> fall back to prefers-color-scheme
        this.applyTheme(null)
        this.persistTheme(null)
    }
}